define(['jquery', 'core/ajax', 'core/str', 'core/url', 'sweetalert2'
],
function($, ajax, str, moodleUrl, Swal) {
    'use strict';
    var index = {
        dom: {
            main: null
        },
        variable: {
            dataTableReference: null
        },
        langs: {
            resendOtp: null,
        },
        action: {
        },

        sendOtp: function(phone, email, fname, lname, utype, e) {
            if (arguments[6]) {
                var sopcemail = arguments[6];
                if (/\s/.test(arguments[2])) {
                    var fname = arguments[2].substring(0, arguments[2].indexOf(' ')),
                    lname = arguments[2].substring(arguments[2].indexOf(' ') + 1);
                } else {
                    var fname = arguments[2],
                    lname = '';
                }
            } else {
                var sopcemail = '',
                fname = fname,
                lname = lname;
            }
            var resendOtp =  str.get_string('resendotp', 'local_custom_auth');
            $.when(resendOtp).done(function(s) {
                index.langs.resendOtp = s;
            });
            var promises = ajax.call([{
                methodname: 'local_custom_auth_get_mobile_otp',
                args: {
                    phone: phone.toString(),
                    email: email.toString(),
                    fname: fname.toString(),
                    lname: lname.toString(),
                    utype: utype.toString(),
                    type: $(e.currentTarget).attr("data-otptype"),
                    spocemail: sopcemail,
                }
            }]);
            promises[0].done(function(result) {
                if (result.status == true) {
                    Swal.fire({
                        position: "center",
                        icon: "success",
                        // Title: "OTP send successfully",
                        text: result.message,
                        showConfirmButton: false,
                        timer: 2500
                    });
                    var counter = 30,
                    timer = null;
                    timer = setInterval(function() {
                        counter--;
                        var resendButton =  str.get_string('resendotpinXseconds', 'local_custom_auth', counter);
                        $.when(resendButton).done(function(s) {
                            if (result.type == 'email') {
                                if (counter == 0) {
                                    $('#btn-send-email-otp').html(index.langs.resendOtp).attr('disabled', false);
                                } else {
                                    $('#btn-send-email-otp').html(s);
                                }
                            } else {
                                if (counter == 0) {
                                    $('#btn-send-otp').html(index.langs.resendOtp).attr('disabled', false);
                                } else {
                                    $('#btn-send-otp').html(s);
                                }
                            }
                        });
                    }, 1000);
                    setTimeout(function() {
                        clearTimeout(timer);
                    }, 30000);
                } else {
                    Swal.fire({
                        position: 'center',
                        // Title: 'Oops...',
                        text: result.message,
                        imageUrl: './pix/error.png',
                        showConfirmButton: false,
                        timer: 2500
                    });
                    $('#btn-send-otp').html(index.langs.resendOtp).attr('disabled', false);
                }
            }).fail(function(result) {});
        },
    };
    return {
        sendOtp: index.sendOtp
    };
});